import type { CodeContent } from '@/types/github';

import { isTestFile } from '@/lib/file-paths/is-test-file';

export function getDefaultCollapsedPrV2Filenames(
  files: Array<Pick<CodeContent, 'filename'>>,
): string[] {
  return files.filter((file) => isTestFile(file.filename)).map((file) => file.filename);
}
